import {Component, OnInit} from '@angular/core';
import {LoadingState} from 'common';
import {BaseComponent} from '../base.component';
import {AccountAdminService} from '../../services/api/account-admin.service';
import {NotificationService} from '../../../../../common/src/lib/services/notification.service';
import {DeviceAdminService} from '../../services/api/device-admin.service';
import {DeviceAccountInformationExportModel} from '../../viewmodels/DeviceAccountInformationExportModel';

@Component({
    selector: 'app-device-notifications-id',
    templateUrl: './notificationsid-device-account-export.component.html',
    styleUrls: ['./notificationsid-device-account-export.component.scss']
})

export class NotificationsidDeviceAccountExportComponent extends BaseComponent implements OnInit {
    public loadingState: LoadingState;
    public loadingStatus: string;
    public rows: DeviceAccountInformationExportModel[];

    constructor(
                private accountAdminService: AccountAdminService,
                private deviceAdminService: DeviceAdminService,
                private notificationService: NotificationService) {
        super();
        this.loadingState = LoadingState.LOADING;
    }

    ngOnInit(): void {
        this.analyticsSwitchPage('Admin-RecentAccountActivityReport', '', '/admin/recentAccountActivityReportOverview');

        this.loadingState = LoadingState.LOADING;

        this.fetchAccountsAndDevices();
    }

    public onExportCsvPressed(): void {
        const csvData = this.convertToCSV(this.rows);
        const today = new Date();

        // Extract and format day, month, and year
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = today.getFullYear();

        const formatted = `${day}_${month}_${year}`;

        this.downloadCSV(csvData, formatted + '_device_notifications_id.csv');
    }

    private convertToCSV(rowModels: DeviceAccountInformationExportModel[]): string {
        if (!rowModels || rowModels.length === 0) {
            return '';
        }

        const header = [
            'Email',
            'Country',
            'NotificationsID',
            'Platform',
            'App Version',
            'User Code',
            'Device Code'
        ];
        const rows = rowModels.map(accountDeviceModel => [
            this.formatValueEscapeCsvCharacters(accountDeviceModel.accountEmail),
            this.formatValueEscapeCsvCharacters(accountDeviceModel.accountCountry),
            this.formatValueEscapeCsvCharacters(accountDeviceModel.notificationsId),
            this.formatValueEscapeCsvCharacters(accountDeviceModel.userAgent),
            this.formatValueEscapeCsvCharacters(accountDeviceModel.appVersion),
            this.formatValueEscapeCsvCharacters(accountDeviceModel.userCode),
            this.formatValueEscapeCsvCharacters(accountDeviceModel.deviceCode),
        ]);

        // Combine header and rows into CSV format
        return [header, ...rows].map(e => e.join(',')).join('\n');
    }

    // Create a Blob and trigger download
    private downloadCSV(csvContent: string, filename: string): void {
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const anchor = document.createElement('a');
        anchor.href = URL.createObjectURL(blob);
        anchor.download = filename;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    }

    private async fetchAccountsAndDevices(): Promise<void> {
        let page = 0;
        const pageSize = 500;
        let hasMore = true;

        let accountAdminDtos = [];

        while (hasMore) {
            const resultAccountAdminDtos = await this.accountAdminService.findAllPagingPersonalDetails(page);
            accountAdminDtos = accountAdminDtos.concat(resultAccountAdminDtos);
            hasMore = resultAccountAdminDtos.length === pageSize;
            page++;
        }

        page = 0;
        hasMore = true;

        let devicesDtos = [];

        while (hasMore) {
            const resultDeviceDtos = await this.deviceAdminService.findAllPagingWithNotificationsId(page);
            devicesDtos = devicesDtos.concat(resultDeviceDtos);
            hasMore = resultDeviceDtos.length === pageSize;
            page++;
        }

        this.rows = DeviceAccountInformationExportModel.from(devicesDtos, accountAdminDtos);
        this.loadingState = LoadingState.LOADED;

        return Promise.resolve();
    }

    // Escaping commas ( , ) and new lines ( \n )
    private formatValueEscapeCsvCharacters(value: string): string {
        if (value === undefined || value === null || value === '') {
            return '-';
        }

        return value.replace(/[,\n]/g, ' ');
    }
}
